import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import postService from "../../Services/post-service";

function ListingVisitationTab({ propertyId }) {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRequestVisit = async () => {
    if (!date || !time) {
      toast.error("Please select a date and time slot");
      return;
    }

    setLoading(true);
    try {
      const response = await postService.requestVisit(propertyId, date, time);
      if (response.data.statusCode === 200) {
        toast.success("Visitation scheduled successfully", { autoClose: 1500 });
        setDate("");
        setTime("");
      } else {
        toast.error(response.data.description || "Failed to schedule visitation");
      }
    } catch (error) {
      toast.error(error?.response?.data?.description || "An error occurred");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="space-y-4">
      <div className="bg-[#F8FAFC] rounded-xl p-4 flex items-start gap-3">
        <InfoOutlinedIcon
          sx={{ fontSize: 20, color: "#00BC67", marginTop: "2px" }}
        />
        <p className="text-[#00BC67] text-[12px] font-[500] leading-relaxed">
          Schedule a guided site visit. Our team will arrange transport and a walkthrough at your convenience.
        </p>
      </div>

      <div className="bg-white rounded-2xl border border-[#F1F5F9] p-5 shadow-2xs space-y-5">
        <div>
          <label className="block text-[#64748B] text-[11px] font-[700] uppercase mb-2">
            PREFERRED DATE
          </label>
          <div className="relative">
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="w-full bg-[#F8FAFC] border-none rounded-xl px-4 py-3.5 text-[#1E222B] text-[13px] font-[500] focus:outline-none focus:ring-2 focus:ring-[#00BC67]/20 appearance-none"
            />
          </div>
        </div>

        <div>
          <label className="block text-[#64748B] text-[11px] font-[700] uppercase mb-2">
            TIME SLOT
          </label>
          <div className="relative">
            <select
              value={time}
              onChange={(e) => setTime(e.target.value)}
              className="w-full bg-[#F8FAFC] border-none rounded-xl px-4 py-3.5 text-[#1E222B] text-[13px] font-[500] focus:outline-none focus:ring-2 focus:ring-[#00BC67]/20 appearance-none"
            >
              <option value="" disabled>Select a time</option>
              <option value="09:00">9:00 AM</option>
              <option value="10:00">10:00 AM</option>
              <option value="11:00">11:00 AM</option>
              <option value="12:00">12:00 PM</option>
              <option value="13:00">1:00 PM</option>
              <option value="14:00">2:00 PM</option>
              <option value="15:00">3:00 PM</option>
              <option value="16:00">4:00 PM</option>
              <option value="17:00">5:00 PM</option>
            </select>
            <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
              <svg
                width="12"
                height="8"
                viewBox="0 0 12 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L6 6.5L11 1.5"
                  stroke="#1E222B"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        <button
          type="button"
          disabled={loading}
          className="w-full py-3.5 bg-[#00BC67] hover:bg-[#00a85c] disabled:opacity-50 text-white text-[14px] font-[700] rounded-xl transition-colors cursor-pointer flex items-center justify-center"
          onClick={handleRequestVisit}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : "Request Visit"}
        </button>
      </div>
    </div>
  );
}

export default ListingVisitationTab;
